import { useProjectContext } from "../context/ProjectContext";
import { DashboardPage } from "./DashboardPage";
import { HierarchyDashboardPage } from "./HierarchyDashboardPage";

export function DashboardSwitcherPage() {
  const { __typename } = useProjectContext();
  switch (__typename) {
    case "Market":
    case "Community":
    case "Subdivision":
      return <HierarchyDashboardPage />;
    default:
      return <DashboardPage />;
  }
}
